import { menuKey } from '../../abs/config/menuKeyConfig';
import routeConfig from '../../abs/config/routeConfig';
import commonUtils from '../../utils/commonUtils';

/**
 * 获取menu的所有key
 * @param {any[]} menus
 */
export function getOpenKeys(menus: any) {
  if (menus && Array.isArray(menus)) {
    return menus.map(item => {
      return item.url ? item.url : item.key;
    });
  }
  return [];
}

/**
 * 获取当前的url
 */
export function getSelectedKey(menus: any) {
  const url = window.location.pathname + window.location.hash;

  if (url.includes('openapi.html#/list')) {
    if ((url === routeConfig.apiList && menus) || !commonUtils.getParams().type) {
      const apiList = menus.find(r => r.key === menuKey.apiList);
      if (apiList && apiList.children.length > 0) {
        return apiList.children[0].url;
      }
    }
    return url;
  }
  if (url.includes('manage/aspx')) {
    return url;
  }
  if (url.includes('analysis/statistics')) {
    return url.split('&')[0];
  }

  const selectedKey = url.split('?')[0];

  if (url.includes('user/follow')) {
    return selectedKey + '?type=product';
  }

  if (url.includes('portfolio/monitor/cashflowdetail')) {
    return selectedKey.replace('detail', '');
  }
  return selectedKey;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSidebar/utils.ts